'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var CircularProgress = _interopDefault(require('@material-ui/core/CircularProgress'));
var CheckCircleOutlineIcon = _interopDefault(require('@material-ui/icons/CheckCircleOutline'));

var CenteredContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  text-align: center;\n  margin: 2rem 1.5rem 1.5rem 1.5rem;\n"], ["\n  text-align: center;\n  margin: 2rem 1.5rem 1.5rem 1.5rem;\n"])));
var StyledCircularProgress = styled__default(CircularProgress)(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  & svg {\n    height: 35px;\n    width: 35px;\n  }\n"], ["\n  & svg {\n    height: 35px;\n    width: 35px;\n  }\n"])));
var StyledCheckCircleOutlineIcon = styled__default(CheckCircleOutlineIcon)(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    fill: " + theme.palette.success.main + "\n ";
});
var templateObject_1, templateObject_2, templateObject_3;

exports.CenteredContainer = CenteredContainer;
exports.StyledCheckCircleOutlineIcon = StyledCheckCircleOutlineIcon;
exports.StyledCircularProgress = StyledCircularProgress;
